<template>
  <div  class="demo2">
    <div class="notice">
      <div class="declaration">
        <div style="text-align: center;margin-bottom: 40px;">
          <h1>SINO WEALTH ELECTRONIC LTD Conflict Free Mineral Declaration</h1>
        </div>
        <div style="margin-bottom: 40px;">
          <p class="declaration-content">
          &nbsp;&nbsp;&nbsp;&nbsp;Conflict minerals originally originated from mining activities in the Democratic Republic of the Congo (DRC) and its neighboring countries. It is an approach that benefits from financing armed groups to provoke conflicts and violate human rights. According to the "Conflict Minerals" clause of the 2010 Dodd Frank Wall Street Reform and Consumer Protection Act, SINO WEALTH ELECTRONIC LTD will actively support the elimination of the use of conflict minerals in our supply chain.
          </p>
        </div>
        <div style="text-align: right;margin-bottom: 40px;">

          <img src="../../assets/images/about/logo.png" style="margin-right: 20px;">

          <div class="declaration-content-imgspan">
            <span style="font-size: 24px;margin-bottom: 20px">SINOWEALTH</span>
          </div>

        </div>

      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "demo2"
    }

</script>

<style >
  .notice{
    padding-top: 33px;
    height: 780px;
    background: url(../../assets/images/about/bj.png);
  }
  .declaration{
    margin: 0 auto;
    padding: 80px;
    height: 100%;
    width: 60%;
    background: #fff;
  }
  .declaration-content{    color: #333333;    font-size: 24px;    line-height: 50px;  }
  .declaration-content-imgspan{    margin: 0 auto;float: right;height: 80px;text-align: center;line-height: 80px;  }
</style>



// WEBPACK FOOTER //
// src/pages/about/sw_notice.vue